// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueGtag from "vue-gtag";
import VueGtm from "@gtm-support/vue2-gtm";
import vueCookies from "vue-cookies";

const App = () =>
	import(/* webpackChunkName: "component-app" */ "@/components/app");
import router from "@/router";
import store from "@/store";
import i18n from "@/common/multilanguage/i18n";
import { GTAG_CONFIG } from "@/common/consts";
import { isFeatureEnabled } from "@/common/feature-toggling";
import nodeConfig from "../package.json";
import {
	initAnalytics,
	trackCLS,
	trackFID,
	trackLCP,
	trackFCP,
} from "@lovetoknow/ltk-analytics";

import "./mixins";

if (typeof window.__PRERENDER_INJECTED === "undefined") {
	Vue.use(VueGtag, GTAG_CONFIG, router);

	const analytics = initAnalytics({
		appName: "wscapes",
		expTrack: true,
		pageTrack: true,
		version: nodeConfig.version,
		debug: isFeatureEnabled("debugCoreVitals"),
	});
	window.$ltkAnalytics = analytics;

	if (isFeatureEnabled("trackCoreVitals")) {
		trackCLS();
		trackFID();
		trackLCP();
		trackFCP();
	}
}

Vue.use(vueCookies);

if (
	typeof window.__PRERENDER_INJECTED === "undefined" &&
	typeof window.__TEST__ === "undefined"
) {
	Vue.use(VueGtm, {
		id: "GTM-5SVHM3B",
		debug: isFeatureEnabled("debugGTM"),
		vueRouter: router,
	});

	/**
	 * @note
	 * Although we are firing the "libload-aditude" custom event here,
	 * this is for future purposes. For now we are loading the Aditude
	 * script tag via the local libLoader library instead of GTM, as
	 * the Aditude team has requested we don't use GTM.
	 */
	if (typeof libloaderPromise !== "undefined") {
		timerPromise.then(() => {
			dataLayer.push({ event: "libload-aditude" });
			libloaderPromise.then(() => {
				libLoader.loadAditude();
			});
		});
	}
}

/* eslint-disable no-new */
new Vue({
	el: "#app",
	i18n,
	router,
	store,
	components: { App },
	template: "<App/>",
});
